import { secondAxios } from "../../../../../../api/axios";

/** GET /doc-transmittal/project/:plantId — DocTransmittal.number per README */
export const getAllDocTransmittalsForPlant = async (plantId) => {
  if (!plantId) return [];
  try {
    const res = await secondAxios.get(`/doc-transmittal/project/${plantId}`);
    return res.data || [];
  } catch (error) {
    console.error("Failed to load doc transmittals for plant", plantId, error);
    return [];
  }
};

export const resolvePlantIdForDocTransmittal = async ({
  plant,
  plantId,
  activeProjectId,
}) => {
  if (plant && plantId) return plantId;
  if (!activeProjectId) return null;
  try {
    const res = await secondAxios.get(`/project/${activeProjectId}`);
    const data = res.data;
    const project =
      typeof data?.data === "string" ? JSON.parse(data.data) : data?.data ?? data;
    const obj = project?.data ?? project;
    return (
      obj?.plantId ??
      obj?.plant?.id ??
      obj?.parentId ??
      obj?.parentPlantId ??
      null
    );
  } catch (error) {
    console.error(
      "Could not resolve plantId for doc transmittals",
      activeProjectId,
      error,
    );
    return null;
  }
};

export const getProjectRACI = async (projectId, type) => {
  // console.log("projecttt", type);
  const response = (
    await secondAxios.get(`/raci/project/${projectId}/type/${type}`)
  ).data;
  // console.log("raciiiiiiiiii", response);
  return response;
};
export const getPlantRaci = async (plantId, type) => {
  // console.log("projecttt", type);
  const response = (await secondAxios.get(`/plant/${plantId}`)).data;
  const projectsRaw =
    response?.projects ||
    (Array.isArray(response?.project)
      ? response.project
      : response?.project
      ? [response.project]
      : Array.isArray(response)
      ? response
      : []);

  // Filter projects by current client
  const filteredProjects = projectsRaw.filter(
    (p) => p.clientName === process.env.REACT_APP_CLIENT_NAME
  );

  let plantRacis = [];
  const normalizedProjects = [];

  filteredProjects.forEach((p) => {
    if (!p) {
      return;
    }
    console.log("p", p);
    const projectName = p.name || p.title || p.projectName;
    const projectId = p.id ?? p.projectId ?? projectName;
    normalizedProjects.push({
      id: projectId,
      name: projectName,
    });
    (p.raci || []).forEach((raci) => {
      plantRacis.push({ ...raci, projectName, projectId });
    });
  });

  return {
    racis: plantRacis,
    projects: normalizedProjects,
  };
};

// export const getRACI = async () => {
//   const raciData = await secondAxios.get("/raci");
//   return raciData;
// };
export const updateRaci = async (id, updatedRaci) => {
  // console.log("updated", updatedRaci);
  const updateRaciDto = {
    document: updatedRaci.document,
    revNum: updatedRaci.revNum,
    docLink: updatedRaci.docLink,
    responsible: updatedRaci.responsible,
  };
  await secondAxios.patch(`/raci/${id}`, updateRaciDto);
};

export const createRaci = async (projectId, newRaci) => {
  // console.log("new raci", newRaci);
  const resp = await secondAxios.post(`/raci/${projectId}`, newRaci);
};

export const deleteRaci = async (id) => {
  try {
    await secondAxios.delete(`/raci/${id}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const archiveRaci = async (id) => {
  await secondAxios.patch(`/raci/${id}`, { archived: true });
};

export const addUsers = async (id, type, usersEmails) => {
  const resp = await secondAxios.post(
    `raci/add-users/${id}/${type}`,
    usersEmails
  );
};

export const getUsers = async (id, type) => {
  const resp = await secondAxios.get(`/raci/get-users/${id}/${type}`);
  return resp.data;
};

export const getRaciById = async (id) => {
  const response = await secondAxios.get(`/raci/${id}`);
  return response.data;
};

export const getVersions = async (raciId) => {
  const response = await secondAxios.get(`/raci/${raciId}/versions`);
  return response.data;
};

export const addVersion = async (raciId, versionData) => {
  const versionDto = {
    version: versionData.version,
    date: versionData.date,
    changes: versionData.changes,
    link: versionData.link,
  };
  await secondAxios.post(`/raci/${raciId}/versions`, versionDto);
};